export const USER_CARD_SMALL_MODE = {
  DEFAULT: 'default',
  MODAL: 'modal',
  USER_LIST: 'userList',
}

export const LINK_MODES = [
  USER_CARD_SMALL_MODE.DEFAULT,
  USER_CARD_SMALL_MODE.USER_LIST,
]

export const SERVICE_USER_TOOLTIP_TITLE = 'Сервисный пользователь'

export const DEACTIVATED_USER_TOOLTIP_TITLE = 'Деактивированный пользователь'
